/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.10",
    versionName: "0.2.0-nightly.2025.7.10",
    versionChannel: "nightly",
    buildDate: "2025-07-10T00:07:50.987Z",
    commitHash: "3a29d23744659a5b3f04c6881d45f4f10b9bccb3",
};
